import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core/dist/esm/es6/rendering/cellRenderers/iCellRenderer';
import { Component } from '@angular/core';
import { ColoredPillTypesEnum } from 'shared/enums/colored-pill-types.enum';
import { CustomColoredPillTypesEnum } from 'shared/enums/custom-colored-pill-types.enum';

@Component({
    selector: 'app-colored-pill-renderer',
    templateUrl: './colored-pill-cell-renderer.component.html',
    styleUrls: ['./colored-pill-cell-renderer.component.scss'],
    standalone: false,
})
export class ColoredPillCellRendererComponent implements ICellRendererAngularComp {
    protected pillType!: ColoredPillTypesEnum | CustomColoredPillTypesEnum;
    protected displayValue!: string;
    protected useFormattedValue: boolean = false;
    protected isMultiPillDisplay: boolean = false;
    protected multiPillsDisplayMapping: { [key: string]: ColoredPillTypesEnum | CustomColoredPillTypesEnum } = {};
    protected valuesArray: string[] = [];
    protected tooltipText!: string | null;

    agInit(
        params: ICellRendererParams & {
            pillType: Function;
            useFormattedValue: boolean;
            isMultiPillDisplay: boolean;
            multiPillsDisplayMapping: { [key: string]: ColoredPillTypesEnum | CustomColoredPillTypesEnum };
            tooltipText?: string;
        },
    ): void {
        this.isMultiPillDisplay = params.isMultiPillDisplay ?? false;
        this.useFormattedValue = params.useFormattedValue ?? false;
        this.tooltipText = params.tooltipText ?? null;

        if (!this.isMultiPillDisplay) {
            this.pillType = params.pillType.call(this, params.value) as ColoredPillTypesEnum | CustomColoredPillTypesEnum;
            this.displayValue = this.useFormattedValue ? params.valueFormatted : params.value;
        } else {
            this.multiPillsDisplayMapping = params.multiPillsDisplayMapping;
            if (!this.multiPillsDisplayMapping) {
                this.pillType = params.pillType.call(this, params.value) as ColoredPillTypesEnum | CustomColoredPillTypesEnum;
            }

            if (this.useFormattedValue && params.valueFormatted) {
                this.valuesArray = params.valueFormatted.split(',');
            } else if (params.value) {
                this.valuesArray = params.value.split(',');
            } else {
                this.valuesArray = [];
            }

            this.valuesArray = this.valuesArray.map((value: string) => value.trim());
        }
    }

    refresh(): boolean {
        return false;
    }
}
